



























import { Vue, Component, Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { FETCH_CHILDREN } from "../store/actions.names";
import { globalToLocalURL } from "../utils/common";
@Component({
  name: "JobCategory"
})
export default class JobCategory extends Vue {
  @Prop() compData!: any;
  @Action(FETCH_CHILDREN) [FETCH_CHILDREN]: any;
  jobs: any[] = [];
  globalToLocalURL: any = globalToLocalURL;

  mounted() {
    this[FETCH_CHILDREN](this.compData.id).then((resp: any) => {
      this.jobs = resp.items;
    });
  }
}
